const initialState = () => {
  return {
    packages: [],
    insights: [],
    tags: []
  }
}
export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/kpis/initialState.js